import { TourVariationViewModel } from '@api/index';

export const DEFAULT_PROMOTION_INFO = {
  promotionDescription: 'Sezon İndirimli',
  promotionName: 'Standart Paket',
};

export const getPromotionInfo = (variation: TourVariationViewModel) => {
  return variation.promotionInfoList?.[0] ?? DEFAULT_PROMOTION_INFO;
};
